<div
  class="container relative"
  [class.cursor-pointer]="(opened$ | async) === false"
  (click)="!opened$.value && clicked.emit()"
>
  <aux-icon [name]="'Message'" class="text-aux-blue-dark" />
  @if (monthlyReviewCount()) {
    <div
      class="absolute left-[15px] top-[-5px] flex h-4 w-4 items-center justify-center rounded-[50%] bg-[#118ee7]"
    >
      <span class="select-none text-xs text-white">
        {{ monthlyReviewCount() }}
      </span>
    </div>
  }
</div>
